import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '@/utils';
import { useState } from 'react';
import { UploadField } from './form';
import { Button, Modal } from './ui';
export var AttachmentsModal = function (_a) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, _c = _a.title, title = _c === void 0 ? 'Attach File' : _c, minHeight = _a.minHeight, _d = _a.accept, accept = _d === void 0 ? '.docx,.doc,.pdf' : _d, handleAttachment = _a.handleAttachment;
    var _e = useState(null), files = _e[0], setFiles = _e[1];
    return (_jsx(Modal, { isOpen: isOpen, isClosable: true, footer: _jsx(_Fragment, {}), onClose: onClose, containerPadding: 'p-2', title: title, modelPadding: 'p-0 vjwMd:p-4', headerClassName: 'px-4', contentWidth: cn("w-full vjwMd:max-w-2xl max-w-full h-full overflow-y-auto", (_b = {
                'vjwMd:h-auto': !minHeight
            },
            _b[minHeight ? "min-h-[".concat(minHeight, "px]") : ''] = !!minHeight,
            _b)), children: _jsxs("form", { className: 'flex w-full h-full flex-col gap-4 p-4', onSubmit: function (e) {
                e.preventDefault();
                if (!(files === null || files === void 0 ? void 0 : files.length))
                    return;
                handleAttachment(files || []);
                onClose();
            }, children: [_jsx(UploadField, { files: files, setFiles: setFiles, multiple: true, className: 'w-full h-full', accept: accept }), _jsxs("div", { className: 'flex gap-4 justify-end', children: [_jsx(Button, { variant: 'secondary', onClick: function () {
                                onClose();
                            }, children: "Cancel" }), _jsx(Button, { variant: 'primary', disabled: !(files === null || files === void 0 ? void 0 : files.length), type: 'submit', children: "Attach" })] })] }) }));
};
